function modifyExpMonth(expMonth) {
  return expMonth < 10 ? `0${expMonth}` : expMonth;
}

function modifyExpYear(expYear) {
  return expYear.toString().slice(2);
}


export const getters = {
  paymentMethods: (state) => {
    return state.methods.map((method) => {
      return {
        id: method.id,
        default: method.default,
        card: {
          brand: method.card.brand,
          last4: method.card.last4,
          expMonth: modifyExpMonth(method.card.expMonth),
          expYear: modifyExpYear(method.card.expYear),
        },
      };
    });
  },
  clientSecret: (state) => state.clientSecret,
  paymentPayload: (state) => state.paymentPayload,
  isCleaningInProgress: (state) => state.isCleaningInProgress,
  payNowActivityId: (state) => state.payNowActivityId,
  invoiceData: (state) => state.invoiceData,
  coupons: (state) => state.coupons,
  payNowEnrollmentData: (state) => state.payNowEnrollmentData,
  isPaymentMethodsLoading: (state) => state.isPaymentMethodsLoading,
};



// WEBPACK FOOTER //
// ./src/store/modules/payment/getters.js